@if (data()) {
  <div class="table-responsive">
    <table class="table table-striped">
      @if (data().data.withHeadings) {
        <thead>
        <tr>
          @for (cell of data().data.content[0]; track cell) {
            <th [innerHTML]="sanitize(cell)"></th>
          }
        </tr>
        </thead>
      }
      <tbody>
        @for (row of data().data.content; let rowIndex = $index; track row) {
          <!-- Falls Überschriften verwendet werden, wird die erste Zeile als Headings genutzt -->
          @if (!data().data.withHeadings || rowIndex > 0) {
            <tr>
              @for (cell of row; track cell) {
                <td [innerHTML]="sanitize(cell)"></td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
}
